export default function VocabLoadingAnimation({className,num, ...props}) {

    return (
        <div className={"flex flex-col "}>
            {
                new Array(num).fill(0).map((item, index) => {
                    return (
                        <div className={`animate border-b-[1px] py-8 animate-pulse flex flex-col gap-2 ${className}`}>
                            <p className={"h-4 rounded-full bg-gray-200 w-1/4"}/>
                            <div className={"flex flex-row gap-2 my-1"}>
                                <p className={"h-4 rounded-full bg-gray-200 w-1/2"}/>
                                <p className={"h-4 rounded-full bg-gray-200 w-8"}/>
                            </div>
                            <p className={"h-7 rounded-lg bg-gray-200 w-full"}/>
                            <p className={"h-7 rounded-lg bg-gray-200 w-full"}/>
                            <p className={"h-7 rounded-lg bg-gray-200 w-full"}/>
                            <p className={"h-7 rounded-lg bg-gray-200 w-full"}/>

                        </div>
                    )
                })
            }

        </div>

    )
}